export default __webpack_public_path__ + "static/media/logo_dome_noir.a60256b5.svg";